import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PageEvent } from '@angular/material/paginator';
import { ActivityDTO } from '../activity/activity.model';
import { ActivityService } from '../../services/acitvity.service';
import { Department } from '../user/department.model';
import { UserService } from '../../services/user.service';
import { FormBuilder, FormGroup, type FormControl } from '@angular/forms';
import { CategoryService } from '../../services/category.service';
import { MultiSelectSearch } from '../../helper/MultiSelectSearch';
import { Activity } from '../../dtos/Activity';
import { IdName } from '../../dtos/IdName';
import { RoleEnum } from '../../enums/role.enum';


@Component({
  selector: 'app-activity-list',
  templateUrl: './activity-list.component.html',
  styleUrl: './activity-list.component.css',
  standalone: false
})
export class ActivityListComponent {
  
  displayedColumns: string[] = [
    'name',
    'type',
    'department',
    'actions',
  ];
  activityData: ActivityDTO[] = [];
  departments: Department[] = [];
  totalActivityCount!: number;
  pageSize: number = 10;
  currentPage: number = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  typeList: {id: number, type: string}[] = [];

  activityList: Activity[] = [];
  userData: any;
  isAdmin: boolean = false;
  isDepartmentAdmin: boolean = false;

  filterForm: FormGroup;

  departmentSearch: MultiSelectSearch<IdName>;
  categoryTypeSearch: MultiSelectSearch<IdName>;
  activitySearch: MultiSelectSearch<IdName>;

  constructor(
    private snackBar: MatSnackBar,
    private activityService: ActivityService,
    private userService: UserService,
    private categoryService: CategoryService,
    private formBuilder: FormBuilder,
  ) {
    this.filterForm = this.formBuilder.group({
      departmentIds: [[],],
      categoryTypeIds: [[],],
      ids: [[],]
    });


    this.departmentSearch = new MultiSelectSearch<IdName>(this.filterForm.get('departmentIds') as FormControl, []);
    this.categoryTypeSearch = new MultiSelectSearch<IdName>(this.filterForm.get('categoryTypeIds') as FormControl, []);
    this.activitySearch = new MultiSelectSearch<IdName>(this.filterForm.get('ids') as FormControl, []);
  }

  ngOnInit(): void {
    this.getStorageData();
    this.getAllActivity();
    this.getActivityCategoryType();
    this.getDepartments();
    this.AllActivities();
  }

  getStorageData() {
    let user: any = sessionStorage.getItem("userData");
    this.userData = JSON.parse(user);
    this.isAdmin = this.userData.roleId == RoleEnum.ADMIN;
    this.isDepartmentAdmin = this.userData.roleId == RoleEnum.DEPARTMENT_ADMIN;
  }

  getCategoryName(categoryTypeId: number): string | undefined {
    if (!this.typeList) {
      return undefined;
    }
    const type = this.typeList.find((t: { id: number; }) => t.id === categoryTypeId);
    return type ? type.type : undefined;
  }

  getActivityCategoryType(): void {
    this.activityService.getActivityCategoryType().subscribe(
      (res: any) => {
        if (Array.isArray(res.responseObject)) {
          this.typeList = res.responseObject.map((activity: any) => ({
            ...activity,
          }));
          this.categoryTypeSearch.setOptions(this.typeList.map(ct => ({id: ct.id, name: ct.type})));
          console.log(this.typeList);
          // this.totalActivityCount = res.responseObject.totalCount; // Set the totalUsersCount property
        } else {
          this.snackBar.open('Error fetching Activity typeList', 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      },
      (error: any) => {
        this.snackBar.open(`Error fetching Activity: ${error.message}`, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }

  AllActivities(): void {
    this.activityService.AllActivities().subscribe(
      (res: any) => {
        if (Array.isArray(res.responseObject)) {
          this.activityList = res.responseObject;
          this.activitySearch.setOptions(this.activityList.map(a => ({id: a.id, name: a.name})));
          console.log("res of activityList:::", res);
          console.log("activityList::::", this.activityList);
          // this.totalActivityCount = res.responseObject.totalCount; // Set the totalUsersCount property
        } else {
          this.snackBar.open('Error fetching Activity: Invalid response format', 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      },
      (error: any) => {
        this.snackBar.open(`Error fetching Activity: ${error.message}`, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }
  
  getAllActivity(): void {
    const filterData = this.filterForm.value;
    this.activityService.getAllActivity(filterData, this.currentPage, this.pageSize).subscribe(
      (res: any) => {
        if(res.responseObject) {
          if (Array.isArray(res.responseObject.activityDTOList)) {
            this.activityData = res.responseObject.activityDTOList.map((activity: ActivityDTO) => ({
              ...activity,
            }));
            this.totalActivityCount = res.responseObject.totalCounts; // Set the totalUsersCount property
          } else {
            this.snackBar.open('Error fetching Activity: Invalid response format', 'Close', {
              duration: 3000,
              verticalPosition: 'bottom',
              horizontalPosition: 'center'
            });
          }
        } else {
          this.activityData = [];
        }
      },
      (error: any) => {
        this.snackBar.open(`Error fetching Activity: ${error.message}`, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }

  onPageChange(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getAllActivity();
  }

  editActivity(element: any): void {
    element.editing = true;
  }

  saveActivity(element: any): void {

    const acitvityData = { ...element };
  
    this.activityService.update(acitvityData).subscribe(
      (res: any) => {
        element.editing = false;
        if(res.status != 200) {
          this.snackBar.open("Failed To Update Activity  as "+res.message, 'Close', { duration: 3000 });
        } else {
          this.snackBar.open('Activity updated successfully!', 'Close', { duration: 3000 });
        }
        this.getAllActivity();
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', { duration: 3000 });
      }
    );
  }

  cancelEdit(element: any): void {
    element.editing = false;
    this.getAllActivity();
  }

  deleteActivity(element: any): void {
    if (confirm(`Are you sure you want to delete activity "${element.name}" ?`)) {
      this.activityService.deleteById(element.id).subscribe(
        (res : any) => {
          if(res.status != 200) {
            this.snackBar.open('Failed to delete As This Activity is Used ', 'close', {duration: 3000});
          }
          // Pass the current page size to the getAllUsers method
          else {
            this.snackBar.open('Activity Deleted successfully!', 'Close', { duration: 3000 });
          }
          this.getAllActivity();
        },
        (error: any) => {
          this.snackBar.open(error.message, 'Close', { duration: 3000 });
        }
      );
    }
  }

  getDepartments(): void {
    this.userService.getDepartments().subscribe(
      (responseObject: Department[]) => {
        this.departments = responseObject.map((department: Department) => ({ id: department.id, departmentName: department.departmentName }));
        this.departmentSearch.setOptions(this.departments.map(d => ({id: d.id, name: d.departmentName})));
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }

  getDepartmentName(departmentId: number): string | undefined {
    if (!this.departments) {
      return undefined;
    }
    const department = this.departments.find(d => d.id === departmentId);
    return department ? department.departmentName : undefined;
  }

  getCategoryType(){
    this.categoryService.getCategoryType().subscribe(
      (res: any) => {
        if (res && res.responseObject) {
          if (Array.isArray(res.responseObject)) {
            this.typeList = res.responseObject.map((type: any) => ({
             ...type,
            }));
          }
        } else {
          this.snackBar.open(res.message, 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }

  onFilter(): void {
    this.getAllActivity();
  }

  clearFilter() {
    this.filterForm.reset({
      departmentIds: [],
      categoryTypeIds: [],
      activityIds: []
    });
    this.getAllActivity();
  }

  
}
